import React from 'react';
import { SectionPaddingSide } from '../../../../components/global/Layout';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import CtaButton from '../../../../components/elements/CtaButton';
import { ValuePropsList, ValuePropItem } from '../../../../components/elements/ValuePropsList';
import { getPricePerMonth, isMonthlyPlan } from './planUtils';
import CtaButtonContainer from '../../../../components/elements/CtaButton/CtaButtonContainer';
import { usePlanSelector } from './hooks';

const styles = require('./PaymentModule.module.css');

const imgURL = `${process.env.REACT_APP_CLOUDFRONT_URL}/accounts`;

function SubscriptionPlan({ plan, onCtaClick, showGlitch, flagText, ctaLabel }) {
  const { descriptionKey, price, trialDurationDays, subscriptionDuration } = plan;

  const isMonthly = isMonthlyPlan(plan);
  const pricePerMonth = getPricePerMonth(plan);
  const billed = isMonthly
    ? `billed ${subscriptionDuration}`
    : `$${price} billed ${subscriptionDuration}ly`;

  const { handleSelectPlan } = usePlanSelector({ onCtaClick });

  return (
    <div className={styles.subscriptionPlanContainer}>
      <div className={styles.subscriptionPlan}>
        <CodeSparkThemedTypography variant="h3" className={styles.subscriptionPlanTitle}>
          {descriptionKey} Plan
        </CodeSparkThemedTypography>
        <CodeSparkThemedTypography variant="h3" className={styles.subscriptionPlanText}>
          ${pricePerMonth}/mo
        </CodeSparkThemedTypography>
        <CodeSparkThemedTypography variant="body3" className={styles.subscriptionPlanIncludes}>
          Includes <span>{trialDurationDays}-Day Free trial</span>
        </CodeSparkThemedTypography>
        <CodeSparkThemedTypography variant="body3" className={styles.subscriptionPlanText}>
          {billed}
        </CodeSparkThemedTypography>

        <CtaButtonContainer>
          <CtaButton onClick={e => handleSelectPlan(e, plan.planId)}>{ctaLabel}</CtaButton>
        </CtaButtonContainer>
      </div>

      {flagText && (
        <div className={styles.subscriptionPlanFlag}>
          <span>{flagText}</span>
        </div>
      )}

      {showGlitch && (
        <div className={styles.subscriptionPlanGlitch}>
          <img src={`${imgURL}/glitch_2_thumbs_up.svg`} role="presentation" alt="Glitch icon" />
        </div>
      )}
    </div>
  );
}

function PlansInclude({ title, listIcon, values }) {
  return (
    <div className={styles.plansInclude}>
      <CodeSparkThemedTypography variant="h5" className={styles.plansIncludeTitle}>
        {title}
      </CodeSparkThemedTypography>

      <ValuePropsList className={styles.plansIncludeList}>
        {values.map((value, i) => {
          return (
            <ValuePropItem
              key={`valueProp_${i}`}
              icon={listIcon}
              iconSize="medium"
              alignItems="flex-start"
            >
              <CodeSparkThemedTypography variant="subtitle2">{value}</CodeSparkThemedTypography>
            </ValuePropItem>
          );
        })}
      </ValuePropsList>
    </div>
  );
}

export default function PlanSelector({
  variant,
  title,
  subscriptionPlans,
  includedInPlans,
  subscriptionPlansProps,
  onCtaClick,
  ctaLabel,
}) {
  return (
    <SectionPaddingSide className={styles.priceModuleSection}>
      <div className={`${styles.priceModuleWrapper} ${styles[variant]}`}>
        <CodeSparkThemedTypography variant="h2" className={styles.priceModuleHeaderTitle}>
          {title}
        </CodeSparkThemedTypography>

        <div className="grid-x grid-margin-x grid-margin-y">
          {subscriptionPlans.map(plan => {
            const planProps = subscriptionPlansProps[plan.subscriptionDuration] || {};

            return (
              <div key={plan.subscriptionDuration} className={'cell small-12 medium-6 large-4'}>
                <SubscriptionPlan
                  plan={plan}
                  onCtaClick={onCtaClick}
                  ctaLabel={ctaLabel}
                  {...planProps}
                />
              </div>
            );
          })}
          <div className="cell small-12 medium-12 large-4 small-order-3">
            <PlansInclude {...includedInPlans} />
          </div>
        </div>
      </div>
    </SectionPaddingSide>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Home/sections/PaymentModule/PlanSelector.js